import { Flex, Image, Text } from "@chakra-ui/react";
import type { LandlordProperties } from "modules/landlord-portal/models/overview";

type PropertyCellProps = {
  row: LandlordProperties;
};

export function PropertyCell({ row }: PropertyCellProps) {
  return (
    <Flex
      direction={"row"}
      gap={{ base: 3, xl: 6 }}
      align={"center"}
      minW={"250px"}
      py={2}
    >
      <Image
        src={row.manage_by_agency_logo ?? "/assets/rex-logo.svg"}
        fallbackSrc={"/assets/rex-logo.svg"}
        alt={"Property image"}
        objectFit={"cover"}
        w={{ base: "30px", xl: "50px" }}
        h={{ base: "30px", xl: "50px" }}
        flexShrink={0}
        borderRadius={"100%"}
        overflow={"hidden"}
      />
      <Flex direction={"column"} gap={1.5} flex={1}>
        <Text fontSize={"lg"} fontWeight={"medium"}>
          {row.display_name}
        </Text>
      </Flex>
    </Flex>
  );
}
